import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import jsCookie from 'js-cookie';
import { HEADERS } from '../../constants';

/* istanbul ignore file */

export function getInfo(postData) {
  return from(axios.post('/infrastructure/sso/getInfo', postData)).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );
}

export function login(postData) {
  const jwtPASSCODEToken = jsCookie.get(HEADERS.X_CM_PASSCODE);
  const nextCMPasscode = jsCookie.get(HEADERS.X_NEXTCM_PASSCODE);
  const commonHeaders = axios.defaults.headers.common;
  if (jwtPASSCODEToken) {
    commonHeaders[HEADERS.X_CM_PASSCODE] = jwtPASSCODEToken;
  }
  if (nextCMPasscode) commonHeaders[HEADERS.X_NEXTCM_PASSCODE] = nextCMPasscode;
  return from(axios.post('/infrastructure/sso/login', postData)).pipe(
    map(({ data: { data } }) => {
      delete axios.defaults.headers.common[HEADERS.X_CM_PASSCODE];
      delete axios.defaults.headers.common[HEADERS.X_NEXTCM_PASSCODE];
      return data;
    })
  );
}

export function getSsoConfig() {
  return from(axios.post('/authentication/public/session/ssoConfig')).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );
}
